// extracted by mini-css-extract-plugin
export default {"outerDiv":"units-page_outerDiv__ptiC0","cardOuterDiv":"units-page_cardOuterDiv__Uvk+n","cNameText":"units-page_cNameText__k09iA","cDescText":"units-page_cDescText__qXWB1"};